<template>
  <v-container>
    <v-card elevation="1">
      <v-card-title class="primary darken-1 white--text font-weight-bold justify-center">
        <v-icon class="mr-2" color="white">mdi-account-arrow-right-outline</v-icon>
        Leave Request Management
      </v-card-title>
      <v-card-title class="pa-6">
        <v-layout row wrap>
          <h4>{{ items[tab] }} Leave Request</h4>
        </v-layout>
      </v-card-title>
      <v-divider class="my-2"></v-divider>
      <v-card-subtitle v-if="error_message" class="white--text error"
      >{{ error_message }}
      </v-card-subtitle>
      <v-card-text>
        <v-tabs
            v-model="tab"
            background-color="primary darken-3"
            dark
            grow
        >
          <v-tab
              v-for="item in items"
              :key="item"
              class="font-weight-bold"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item
              v-for="(item) in items"
              :key="item"
          >
            <v-card
                color="basil"
                flat
            >
              <v-card-text>
                <v-data-table
                    :footer-props="{ 'items-per-page-options': itemsPerPage }"
                    :headers="getHeaders(item)"
                    :items="getItems(item)"
                    :loading="loading"
                    :options.sync="options"
                    class="elevation-1 mt-3"
                    item-key="id"
                    style="cursor: pointer"
                >
                  <template v-if="tab === 0" v-slot:item.actions="{ item }">
                    <v-btn
                        rounded
                        color="primary"
                        small
                        class="my-2"
                        @click="approve(item.id)"
                    >
                      Approve
                    </v-btn>
                    <v-btn
                        rounded
                        small
                        color="error"
                        @click="reject(item.id)"
                        class="mb-2"
                    >
                      Decline
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import axios from "axios";

export default {
  name: 'Export',
  created() {
    this.getData();
  },
  data: function () {
    return {
      tab: null,
      items: [
        'Pending', 'Approved', 'Rejected',
      ],
      error_message: null,
      pendingHeader: [],
      pendingData: [],
      approvedHeader: [],
      approvedData: [],
      rejectedHeader: [],
      rejectedData: [],
      options: {itemsPerPage: 10},
      loading: false,
    }
  },
  methods: {
    getData() {
      axios.get(`/utils/getLeaveData`).then(({data}) => {
        console.log(data.headers)
        this.pendingHeader = [...data.headers,{ text: 'Actions', value: 'actions', sortable: false } ];
        this.approvedHeader = data.headers;
        this.rejectedHeader = data.headers;
        for (const entry of data.data) {
          if(entry.status === 'Pending') {
            this.pendingData.push(entry);
          } else if(entry.status === 'Approved') {
            this.approvedData.push(entry);
          } else if(entry.status === 'Rejected') {
            this.rejectedData.push(entry);
          }
        }
      })
          .catch(error => {
            this.error_message = error.message
          })
    },
    getHeaders(item) {
      if (item === "Pending") {
        return this.pendingHeader
      }
      if (item === "Approved") {
        return this.approvedHeader
      }
      if (item === "Rejected") {
        return this.rejectedHeader
      }
    },
    getItems(item) {
      if (item === "Pending") {
        return this.pendingData
      }
      if (item === "Approved") {
        return this.approvedData
      }
      if (item === "Rejected") {
        return this.rejectedData
      }
    },
    approve(id) {
      axios.post(`/utils/approveLeaveRequest/${id}`).then((response) => {
        this.$router.go()
        console.log("response",response)
      }).catch(error => {
        console.log(JSON.stringify(error.response.data,null,2))
        this.loading = false;
        this.error_message = error.response.data.message
      })
    },
    reject(id) {
      this.loading = true;
      axios.post(`/utils/rejectLeaveRequest/${id}`).then((response) => {
        console.log("response",response)
        this.$router.go()
      }).catch(error => {
        this.loading = false;
        this.error_message = error.message
      })
    },
  },
  computed: {
    itemsPerPage() {
      return [5, 10, 20, 50];
    },
  },
  watch: {}
}
</script>

<style>
.basil {
  background-color: #FFFBE6 !important;
}
</style>